<template>
  <div>
    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 footer-copyright">
            <p class="mb-0">© 2021 by ONTrac LLC</p>
          </div>
          <div class="col-md-6">
            <p class="pull-right mb-0">
              <a href="https://www.startontrac.com/privacy" target="_blank">Privacy Policy</a> - <a href="https://www.startontrac.com/terms-of-service" target="_blank">Terms of Service</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import json from '../data/menu'
export default {
  name: 'footerpage',
  data(){
    return{
      customizer :false,
      data:"data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(json)),
    }
  }
}
</script>
<style scoped lang="scss">
 a {
   font-weight: normal;
   color: #626262;

   &:hover {
     color: #4466f2;
   }
 }
</style>
